import { execAdmin } from '@src/apis/reware/utils';

import type { QueueStatusResponse, FetchQueueStatusExecResponse } from './types';

export const fetchQueueStatus = async (): Promise<QueueStatusResponse[]> => {
  const query = `
    query getShopifySyncQueueStatus {
      shopifySyncQueueStatus {
        name
        messagesPending
        messagesProcessing
        throughputPerMinute
        estimatedMinutesToClear
        error
      }
    }
  `;

  const data = await execAdmin<Record<string, never>, FetchQueueStatusExecResponse>(
    query,
    { variables: {} },
  );

  return data.shopifySyncQueueStatus;
};
